import React, { Component, Fragment } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import TextField from '@material-ui/core/TextField';

import theme from '../../muiTheme';

const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
}

class NarrativeDialog extends Component {

  render() {
    return (
      <Fragment>
      <Dialog
       modal={true}
       open={this.props.open}
       contentStyle={styles.errorDialogContent}
       titleStyle={styles.errorDialogTitle}>
       <TextField
         style={{width: '400px !important'}}
         id="filled-multiline-static"
         label="Report Narrative"
         multiline
         fullWidth={true}
         rows="20"
         defaultValue={this.props.defaultValue}
         margin="normal"
         variant="filled"
          onChange={(event, value) =>
            {
              this.props.onChange(event, event.currentTarget.value);
            }
          }
         />
       <DialogActions>
        <Button onClick={this.props.onClose} color="primary">
          Close
        </Button>
      </DialogActions>
     </Dialog>
      </Fragment>
    )
  }
}

export default NarrativeDialog;
